import { t } from '@lingui/core/macro';
import { ItemClass } from '@luminovo/api-contracts';
import { FieldSelect, FieldSelectProps } from '@luminovo/design-system';
import { transEnum } from '@luminovo/frontend-utils';
import * as React from 'react';
import type { JSX } from 'react';

import { itemClassTranslations } from '../../i18n';

export const FieldItemClass = React.memo(function FieldItemClass(
    props: Omit<FieldSelectProps<ItemClass>, 'options'>,
): JSX.Element {
    return (
        <FieldSelect
            options={Object.values(ItemClass)}
            getOptionLabel={(opt) => transEnum(opt, itemClassTranslations)}
            placeholder={t`Item class`}
            {...props}
        />
    );
});
